module.exports = __webpack_public_path__ + "assets/images/29-4.jpg";